import styled from 'styled-components';
import Expectation from './Expectation';

const ListDiv = styled.div`
  width: 100%;
  gap: 16px;
  opacity: 1;
  border-radius: 8px;
  border-width: 1px;
  padding-top: 16px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  top: 40px;
  border: 1px solid var(--color-border-tertiary);
  background-color: var(--color-bg-primary);
`;

const ExpectationList = ({
  expectations,
  variant,
  rewardName,
}: {
  expectations: {
    key: string;
    field: string;
    label: string;
    isPassed: boolean;
    actual: string;
    target: string;
  }[];
  variant: 'slideout' | 'overview' | 'tooltip';
  // The reward these criteria belong to — threaded so a criterion name shared across rewards
  // resolves to the correct instance.
  rewardName?: string;
}) => {
  return (
    <ListDiv>
      {expectations.map(({ key, ...rest }) => (
        <Expectation
          key={key}
          {...rest}
          variant={variant}
          rewardName={rewardName}
        />
      ))}
    </ListDiv>
  );
};

export default ExpectationList;
